// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"33f8de9e","99":"499dfd44","407":"73251344","434":"59747a77","448":"85844bf5","521":"619d0655","728":"e9574f14","744":"148e502d","835":"a5c7e9b9","898":"c9fc3b44","948":"1c22b92e","951":"39812372"}[chunkId] + ".chunk.js";
};